module.exports = __webpack_public_path__ + "static/media/wolf_sword.553ffbe9.png";